import React, { useState, useEffect } from "react";
import { Form, Button } from "@oxygen/core";
import { EmailInput } from "../components/FormInputs";
import CarwaleLoginApi from "../apis";
import { makeCancelable } from "GlobalUtils/CancelablePromise";
import { validateInput } from "../utils";
import { closeAccountPopup, setCurrentScreen } from "../actionCreator";
import { SCREEN } from "../constants/Global";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import SpeedometerLoader from "GlobalComponent/SpeedometerLoader";
import useInput from "../hooks/useInput";
import useReCaptcha from "../hooks/useReCaptcha";
import { validateEmail } from "GlobalUtils/Validate";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "GlobalConstant/";
import styles from "./scss/ForgotPassword.module.scss";
import getThemeClasses from "@oxygen/theme";

const propTypes = {
  /** Function to display feedback to user (like showing toast) */
  showToast: PropTypes.func.isRequired,
};

const loginClasses = getThemeClasses(`
  mt-5;
  text-align-center;
  color-blue-light;
  font-size-7.5;
  cursor-pointer;
`);

/**
 * This component is used to reset password
 * Handles api calls and validations
 */
let apiPromise = null;
const ForgotPassword = ({ platForm, showToast }) => {
  const [email, setEmail, onEmailChange] = useInput(validateEmail);
  const [isFetching, setIsFetching] = useState(false);
  const dispatch = useDispatch();
  const { reCaptchaRef, triggerRecaptcha } = useReCaptcha();

  useEffect(() => {
    return () => {
      apiPromise && apiPromise.cancel();
    };
  }, []);

  const handleLoginClick = () => {
    dispatch(setCurrentScreen(SCREEN.LOG_IN));
  };

  const handleResetPasswordResponse = response => {
    if (response && response.status === 200) {
      showToast(response.message);
      if (response.isResetDone) {
        dispatch(closeAccountPopup());
      }
    } else {
      showToast((response && response.message) || "Please try again later");
    }
    setIsFetching(false);
  };
  const onSubmit = event => {
    event.preventDefault();
    const inputValidation = validateInput({
      email: email.value,
    });
    if (!inputValidation.isValid) {
      const { validation } = inputValidation;
      setEmail({ ...email, ...validation.email });
      return;
    }
    triggerRecaptcha();
  };
  function handleResetPassword(reCaptchaResponse) {
    setIsFetching(true);
    apiPromise && apiPromise.cancel();
    apiPromise = makeCancelable(
      CarwaleLoginApi.cwResetPassword({
        emailId: email.value,
        reCaptchaResponse,
        platForm,
      })
    );
    apiPromise.promise.then(handleResetPasswordResponse).catch(error => {
      console.log("ResetPassword Api failed", error);
      showToast("Reset Password failed");
      setIsFetching(false);
    });
  }

  return (
    <>
      {isFetching && <SpeedometerLoader />}
      <Form>
        <EmailInput
          email={email}
          label="email"
          handleEmailInput={onEmailChange}
        />
        <div className={styles.resetPassword}>
          <Button htmlType="submit" block onClick={onSubmit}>
            Reset Password
          </Button>
        </div>
      </Form>
      <div className={loginClasses} onClick={handleLoginClick}>
        Back to Login
      </div>
      <ReCAPTCHA
        ref={reCaptchaRef}
        sitekey={RECAPTCHA_SITE_KEY}
        size="invisible"
        badge="bottomright"
        onChange={handleResetPassword}
      />
    </>
  );
};

ForgotPassword.displayName = "ForgotPassword";
ForgotPassword.propTypes = propTypes;
export default ForgotPassword;
